import { render } from "./CreatePage.vue?vue&type=template&id=7fa3c92c&scoped=true"
import script from "./CreatePage.vue?vue&type=script&lang=js"
export * from "./CreatePage.vue?vue&type=script&lang=js"

import "./CreatePage.vue?vue&type=style&index=0&id=7fa3c92c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa3c92c"]])

export default __exports__